<template id="bbb">
  <div class="fashion">
    <v-head></v-head>
    <div class="fashion_content clearfix">
      <div>
        <a v-link="{path:'/space'}"> <img :src="fashion_left" alt=""></a>
      </div>
      <div class="fashion_content_two">
         <!--<span>
           <a v-link="{path:'/gc_boadcast'}"><img :src="fashion_right_top" alt=""></a>
         </span>-->
        <span>
          <a v-link="{name:'n_select', params: { name: fashion_right_bottom.ids}}"><img :src="fashion_right_bottom.imgs" alt=""></a>
         </span>
      </div>

    </div>
    <v-footer></v-footer>
    <!--<page></page>-->

  </div>

</template>

<script>
  import head from 'components/head/head.vue';
  import footer from 'components/footer/footer.vue';
  export default {
    name:'two',
    data () {
      return {
        fashion_left:{},
        fashion_right_top:{},
        fashion_right_bottom:{
          imgs:"",
          ids:""
        },
        ell:""
      }
    },
    components: {
      "v-head": head,
      "v-footer": footer,
    },
    methods:{
      abc:function () {
        console.log(77777,this.ell)
      },
    },
    ready () {
      var _this = this;
      console.log(8383,this.all);
      this.all = 20;
      console.log(9494,this.all);
      $.ajax({
        type: "get",
        url: __formalUrl__ + "api/getImageTypeById/28",
        dataType: "json",
        success: function (data) {
          if (data) {
            _this.fashion_left = data.image;
          }
        },
      });
      $.ajax({
        type: "get",
        url: __formalUrl__ + "api/getImageTypeById/27",
        dataType: "json",
        success: function (data) {
          if (data) {
            _this.fashion_right_top = data.image;
          }
        },
      });
      $.ajax({
        type: "get",
        url: __formalUrl__ + "api/getImageTypeById/26",
        dataType: "json",
        success: function (data) {
          if (data) {
            _this.fashion_right_bottom.imgs = data.image;
            _this.fashion_right_bottom.ids = data.id;
          }
        },
      });
    }
  }
</script>

<style>
  .fashion{width: 9rem;margin: 0 auto;}
  .fashion_content{width:9rem;margin-top: 0.5rem}
  .fashion_content div:first-child{float: left;width: 4.45rem;}
  .fashion_content div:last-child{float: right;width: 4.45rem}
  .fashion_content img{width: 100%}
  .fashion_content_two{width:4.45rem}
  .fashion_content_two span{width: 4.45rem}
  @media screen and (max-width: 30em) and (min-width:20em ){
    .fashion{width: 100%;margin: 0 auto;}
    .fashion_content{width:100%;margin-top: 0.5rem}
    .fashion_content div:first-child{float: none;width: 100%;margin-bottom: 0.05rem;}
    .fashion_content div:last-child{float: none;width: 100%}
    .fashion_content img{width: 100%}
    .fashion_content_two{width:100%}
    .fashion_content_two span{width: 100%}
  }
</style>



// WEBPACK FOOTER //
// fashion.vue?d6e68000